/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from '../security/components/login/login.component';
import { DisclaimerComponent } from '../security/components/disclaimer/disclaimer.component';
import { AuthenticationComponent } from '../security/components/authentication.component';
import { MapContainerComponent } from '../../modules/map/components/map-container.component';
import { AuthenticatedGuard } from './guards/authenticated.guard';
import { RootUrlGuard } from './guards/root-url.guard';
import { RootComponent } from '../root/root.component';
import { DisabledRouteGuard } from './guards/disabled-route.guard';
import { NoManualAuthenticationGuard } from './guards/no-manual-authentication.guard';
import { AdminAreaGuard } from './guards/admin-area.guard';
import { ForgotPasswordComponent } from '../security/components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from '../security/components/password/reset-password/reset-password.component';
import { ConfirmAccountComponent } from '../security/components/confirm-account/confirm-account.component';

export const csCoreRoutes: Routes = [
    {
        path: '',
        component: RootComponent,
        pathMatch: 'full',
        runGuardsAndResolvers: 'always',
        canActivate: [RootUrlGuard],
    },
    {
        path: 'map',
        component: MapContainerComponent,
        canActivate: [DisabledRouteGuard],
        runGuardsAndResolvers: 'always',
    },
    {
        path: 'dashboard',
        loadChildren: () => import('../../modules/dashboard/dashboard.module').then((m) => m.DashboardModule),
        canLoad: [DisabledRouteGuard],
        runGuardsAndResolvers: 'always',
    },
    {
        path: 'admin',
        loadChildren: () => import('../../modules/admin/admin.module').then((m) => m.AdminModule),
        canLoad: [AdminAreaGuard],
        runGuardsAndResolvers: 'always',
    },
    {
        path: 'auth',
        component: AuthenticationComponent,
        canActivate: [NoManualAuthenticationGuard],
        children: [
            { path: 'login', component: LoginComponent },
            { path: 'disclaimer', component: DisclaimerComponent },
            { path: 'forgot', component: ForgotPasswordComponent },
            { path: 'reset', component: ResetPasswordComponent },
            { path: 'confirm', component: ConfirmAccountComponent },
        ],
    },
    { path: '**', redirectTo: '' },
];

@NgModule({
    imports: [RouterModule.forRoot(csCoreRoutes, { enableTracing: false, relativeLinkResolution: 'corrected' })],
    exports: [RouterModule],
    providers: [AuthenticatedGuard, AdminAreaGuard, RootUrlGuard, DisabledRouteGuard],
})
export class AppRouterModule {}
